<template>
	<v-sheet elevation="0">
		<CommonFlame :title="title">
			<template v-if="!selectedMatter">
				<h6 class="text-body-1 font-weight-bold mt-2">参照元案件データ</h6>
				<v-form ref="searchForm">
					<v-row no-gutters justify="space-between">
						<v-col cols="12" sm="6" lg="4" class="px-1">
							<v-text-field
								label="見積番号"
								v-model="q.todo"
								class="mt-4"
								outlined
								clearable
								dense
							/>
						</v-col>
						<v-col cols="12" sm="6" lg="4" class="px-1">
							<v-text-field label="向け先" v-model="q.todo" class="mt-4" outlined clearable dense />
						</v-col>
						<v-col cols="12" sm="6" lg="4" class="px-1">
							<v-text-field label="得意先" v-model="q.todo" class="mt-4" outlined clearable dense />
						</v-col>
						<v-col cols="12" sm="6" lg="4" class="px-1">
							<v-menu
								:close-on-content-click="false"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<!-- TODO 範囲選択にする -->
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="q.todo"
										label="案件作成時期"
										class="mt-4"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
									/>
								</template>
								<v-date-picker class="date-picker" v-model="q.todo" no-title locale="ja-JP" />
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
							<v-row no-gutters>
								<v-col cols="6" class="pr-1">
									<v-btn width="100%" @click="fetchMatters(1)" color="secondary">
										<v-icon class="mr-2">mdi-magnify</v-icon>
										検索</v-btn
									>
								</v-col>
								<v-col cols="6" class="pl-1">
									<v-btn width="100%" @click="resetForm" outlined color="secondary">
										<v-icon class="mr-2">mdi-autorenew</v-icon>
										クリア</v-btn
									>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-form>
				<div class="table-container mt-2 pa-2">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="matters"
						item-key="name"
						class="elevation-1"
						:mobile-breakpoint="240"
						disable-filtering
						disable-pagination
						disable-sort
						hide-default-footer
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr @click="setMatter(item)">
								<td>{{ item.name }}</td>
								<td>{{ item.regular_customer_company.name }}</td>
								<!-- <td>{{ item.contract == true ? "成約" : "未定" }}</td> -->
								<td>{{ item.situation }}</td>
								<td class="products">
									<template v-if="item.order_products && item.order_products.length">
										<v-row
											v-for="(order_product, i) in item.order_products"
											:key="i"
											class="py-1"
											no-gutters
										>
											<v-col cols="6"
												>{{ order_product.product.name }}{{ order_product.sub_name }}</v-col
											>
											<v-col cols="4">{{ order_product.product.product_category.name }}</v-col>
											<v-col cols="2">{{ order_product.quantity }}個</v-col>
										</v-row>
									</template>
									<template v-else-if="item.matter_products && item.matter_products.length">
										<v-row
											v-for="(matter_product, i) in item.matter_products"
											:key="i"
											class="py-1"
											no-gutters
										>
											<v-col cols="6"
												>{{ matter_product.product.name }}{{ matter_product.sub_name }}</v-col
											>
											<v-col cols="4">{{ matter_product.product.product_category.name }}</v-col>
											<v-col cols="2">{{ matter_product.quantity }}個</v-col>
										</v-row>
									</template>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
				<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
			</template>

			<template v-else>
				<v-form ref="form" v-model="valid">
					<v-container>
						<v-row no-gutters justify="space-between">
							<h5 class="text-body-1 font-weight-bold">選択された案件データ</h5>
							<v-btn color="secondary" @click="resetMatter">
								<v-icon class="mr-1"> mdi-arrow-left </v-icon>
								案件を選択し直す
							</v-btn>
						</v-row>
						<v-row no-gutters>
							<h6 class="font-weight-bold mr-2">対象案件</h6>
							<p>
								<a @click="openMatterDialog">
									{{ selectedMatter.name }}
								</a>
							</p>
						</v-row>
						<v-divider class="my-4" />
						<v-row no-gutters class="mt-4" justify="end">
							<v-btn color="secondary" :disabled="!valid" @click="submitForm('draft')">
								<v-icon class="mr-1">mdi-content-save-outline</v-icon> 下書き保存
							</v-btn>
							<v-btn class="ml-2" color="secondary" :disabled="!valid" @click="openConfirmDialog">
								<v-icon class="mr-1">mdi-plus</v-icon> 作成して確認を依頼
							</v-btn>
						</v-row>
						<QuotationForm :quotation_data.sync="quotation" />
					</v-container>
				</v-form>
			</template>
		</CommonFlame>
		<QuotationConfirmDialog
			:dialog.sync="confirmDialog"
			:matter="selectedMatter"
			:quotation="quotation"
		/>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"

import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../shared/PaginationModule.vue"
import QuotationForm from "./components/QuotationForm.vue"
import QuotationConfirmDialog from "./components/QuotationConfirmDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		QuotationForm,
		QuotationConfirmDialog,
	},
	data() {
		return {
			title: "見積作成",
			quotation: {
				files: [],
			},
			selectedMatter: null,
			matters: [],
			headers: [
				{ text: "案件名", value: "name", width: "200px" },
				{ text: "得意先", value: "regular_customer_company.name", width: "200px" },
				{ text: "確度", value: "situation_i18n", width: "80px" },
				{ text: "製品情報", value: "products", width: "300px" },
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},

			q: {
				sorts: null,
			},

			confirmDialog: false,

			valid: false,
			errors: [],
			rules,
		}
	},
	mounted() {
		if (this.$route.query.matter_id) {
			// TODO matterをfetch
		}
	},
	methods: {
		fetchMatters(page) {
			const headers = authenticate.setHeader()
			const params = { q: this.q, page }
			const url = `/erp/v1/quotations/search_matters`
			axios
				.get(url, { headers, params })
				.then((res) => {
					this.matters = res.data.matters
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchMatters(page)
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		setMatter(matter) {
			this.selectedMatter = matter
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		resetMatter() {
			// TODO
			this.selectedMatter = null
		},
		resetForm() {
			this.$refs.searchForm.reset()
		},
		openMatterDialog() {
			// TODO
		},
		openConfirmDialog() {
      this.confirmDialog = true
    },
		submitForm(status) {
			// TODO
			const headers = authenticate.setHeader()
			const params = { quotation: this.quotation }
			const url = "/erp/v1/quotations"
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.$router.push({ name: "quotation_index" })
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
}
</script>